/* IU Navigation 3.12 — native Ella panels and the existing IU search engine. */
(() => {
  'use strict';
  function init() {
    if (document.documentElement.dataset.iuNavigationReady) return;
    document.documentElement.dataset.iuNavigationReady = 'true';
    const mobile = matchMedia('(max-width:1024px)');
    const specs = [
      {id:'navigation-mobile',state:'menu_open',trigger:'[data-mobile-menu]',close:'[data-menu-close-sidebar]'},
      {id:'search-form-mobile',state:'open_search_mobile',trigger:'[data-search-mobile]',close:'[data-search-close-sidebar]'}
    ].map(spec => ({...spec,panel:document.getElementById(spec.id),opener:null,open:false})).filter(spec=>spec.panel);
    let active = null;
    const blocked = new Map();
    const background = () => [...document.querySelectorAll('#MainContent,.iu-footer,.shopify-section-group-header-group,.halo-sticky-toolbar-mobile')];
    const focusables = panel => [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),summary,[tabindex="0"]')].filter(e=>e.getClientRects().length&&!e.closest('[inert]')&&getComputedStyle(e).visibility!=='hidden');
    const close = spec => {if(!spec)return;spec.panel.querySelector(spec.close)?.click();document.body.classList.remove(spec.state);};
    const lockBackground = on => {
      if (on) background().forEach(e=>{if(!blocked.has(e))blocked.set(e,e.inert);e.inert=true;});
      else {blocked.forEach((value,e)=>{e.inert=value;});blocked.clear();}
      if(document.body.classList.contains('iu-nav-dialog-open')!==on)document.body.classList.toggle('iu-nav-dialog-open',on);
    };
    const focusPanel = spec => {
      let attempts=0;
      const focus=()=>{
        if(!spec.open||!mobile.matches)return;
        const target=focusables(spec.panel).find(e=>e.matches('input[name="q"]'))||focusables(spec.panel)[0];
        target?.focus({preventScroll:true});
        if(!spec.panel.contains(document.activeElement)&&++attempts<40)requestAnimationFrame(focus);
      };
      // A panel becomes focusable after Ella's visibility transition begins.
      requestAnimationFrame(()=>requestAnimationFrame(focus));
    };
    const sync = () => {
      let opened = mobile.matches ? specs.find(spec=>document.body.classList.contains(spec.state)) : null;
      if (opened) specs.forEach(spec=>{if(spec!==opened&&document.body.classList.contains(spec.state))close(spec);});
      let restore=null;
      specs.forEach(spec=>{
        const on=spec===opened;
        spec.panel.inert=!on;
        spec.panel.setAttribute('aria-hidden',String(!on));
        if(on)spec.panel.setAttribute('aria-modal','true');else spec.panel.removeAttribute('aria-modal');
        document.querySelectorAll(spec.trigger).forEach(e=>{e.setAttribute('aria-controls',spec.id);e.setAttribute('aria-expanded',String(on));});
        if(spec.open&&!on&&!opened&&mobile.matches)restore=spec.opener;
        spec.open=on;
      });
      lockBackground(Boolean(opened));
      if(restore?.isConnected)restore.focus({preventScroll:true});
      if(opened&&opened!==active){
        focusPanel(opened);
      }
      active=opened;
    };
    document.addEventListener('click',event=>{
      if(!(event.target instanceof Element))return;
      for(const spec of specs){const trigger=event.target.closest(spec.trigger);if(trigger){spec.opener=trigger;specs.forEach(other=>{if(other!==spec&&other.open)close(other);});}}
      const queryLink=event.target.closest('[data-iu-search-query]');
      if(queryLink){
        if(window.IUStoreSearch)queryLink.href=window.IUStoreSearch.url(queryLink.dataset.iuSearchQuery,queryLink.href).href;
        // Keep the browser's modified-click behavior instead of the theme's target listener.
        if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)event.stopImmediatePropagation();
      }
    },true);
    document.addEventListener('keydown',event=>{
      if(!active)return;
      if(event.key==='Escape'){event.preventDefault();event.stopImmediatePropagation();close(active);return;}
      if(event.key!=='Tab')return;
      const items=focusables(active.panel),first=items[0],last=items[items.length-1];
      if(!first){event.preventDefault();return;}
      if(event.shiftKey&&(document.activeElement===first||!active.panel.contains(document.activeElement))){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&(document.activeElement===last||!active.panel.contains(document.activeElement))){event.preventDefault();first.focus();}
    },true);
    // Same normalizer as submitted searches; no duplicate query or filter logic.
    document.querySelectorAll('[data-iu-search-query]').forEach(e=>{if(window.IUStoreSearch)e.href=window.IUStoreSearch.url(e.dataset.iuSearchQuery,e.href).href;});
    new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});
    mobile.addEventListener('change',()=>{if(!mobile.matches)specs.filter(spec=>spec.open).forEach(close);sync();});
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
